import React from 'react';
import { faCloudSunRain } from '@fortawesome/pro-solid-svg-icons/faCloudSunRain';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CloudSunRainSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCloudSunRain} {...props} />;
}
